import React from 'react';

interface OverviewIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const OverviewIcon: React.FC<OverviewIconProps> = ({ 
  width = 24, 
  height = 24, 
  className 
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1429 11.1429C11.1429 10.1957 10.3757 9.42857 9.42857 9.42857H1.71429C0.767143 9.42857 0 10.1957 0 11.1429C0 13.4803 0 19.9483 0 22.2857C0 23.2329 0.767143 24 1.71429 24H9.42857C10.3757 24 11.1429 23.2329 11.1429 22.2857V11.1429Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8571 12.8571C12.8571 13.8043 13.6243 14.5714 14.5714 14.5714H22.2857C23.2329 14.5714 24 13.8043 24 12.8571C24 10.5197 24 4.05171 24 1.71429C24 0.767143 23.2329 0 22.2857 0H14.5714C13.6243 0 12.8571 0.767143 12.8571 1.71429V12.8571Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1429 1.71429C11.1429 0.767143 10.3757 0 9.42857 0H1.71429C0.767143 0 0 0.767143 0 1.71429C0 2.85514 0 4.85914 0 6C0 6.94714 0.767143 7.71429 1.71429 7.71429H9.42857C10.3757 7.71429 11.1429 6.94714 11.1429 6V1.71429Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8571 22.2857C12.8571 23.2329 13.6243 24 14.5714 24H22.2857C23.2329 24 24 23.2329 24 22.2857C24 21.1449 24 19.1409 24 18C24 17.0529 23.2329 16.2857 22.2857 16.2857H14.5714C13.6243 16.2857 12.8571 17.0529 12.8571 18V22.2857Z"
        fill="white"
      />
    </svg>
  );
};

